// eslint-disable-next-line max-classes-per-file
export const REDUCER_KEY_RS_ADD_STEPS = 'rsAddSteps';

export const SHOW_ADD_STEPS_DIALOG = 'rs/SHOW_ADD_STEPS_DIALOG';
export const HIDE_ADD_STEPS_DIALOG = 'rs/HIDE_ADD_STEPS_DIALOG';
export const FETCH_PUBLISHED_STEPS = 'rs/FETCH_PUBLISHED_STEPS';
export const FETCH_PUBLISHED_STEPS_SUCCESS = 'rs/FETCH_PUBLISHED_STEPS_SUCCESS';
export const FETCH_PUBLISHED_STEPS_FAILURE = 'rs/FETCH_PUBLISHED_STEPS_FAILURE';
export const FETCH_IN_HOUSE_STEPS_BY_DATABASE = 'rs/FETCH_IN_HOUSE_STEPS_BY_DATABASE';
export const FETCH_IN_HOUSE_STEPS_BY_DATABASE_SUCCESS = 'rs/FETCH_IN_HOUSE_STEPS_BY_DATABASE_SUCCESS';
export const FETCH_IN_HOUSE_STEPS_BY_DATABASE_FAILURE = 'rs/FETCH_IN_HOUSE_STEPS_BY_DATABASE_FAILURE';
export const FETCH_PREDICTED_STEPS = 'rs/FETCH_PREDICTED_STEPS';
export const FETCH_PREDICTED_STEPS_SUCCESS = 'rs/FETCH_PREDICTED_STEPS_SUCCESS';
export const FETCH_PREDICTED_STEPS_FAILURE = 'rs/FETCH_PREDICTED_STEPS_FAILURE';
export const FETCH_PREDICTED_STEPS_EXAMPLES = 'rs/FETCH_PREDICTED_STEPS_EXAMPLES';
export const FETCH_PREDICTED_STEPS_EXAMPLES_SUCCESS = 'rs/FETCH_PREDICTED_STEPS_EXAMPLES_SUCCESS';
export const FETCH_PREDICTED_STEPS_EXAMPLES_FAILURE = 'rs/FETCH_PREDICTED_STEPS_EXAMPLES_FAILURE';
export const SET_SELECTED_INDEXES_BY_TAB = 'rs/SET_SELECTED_INDEXES_BY_TAB';
export const ADD_STEPS = 'rs/ADD_STEPS';
export const ADD_STEPS_SUCCESS = 'rs/ADD_STEPS_SUCCESS';
export const ADD_STEPS_FAILURE = 'rs/ADD_STEPS_FAILURE';

export const ADD_STEPS_CLEAR_STATE = 'rs/ADD_STEPS_CLEAR_STATE';

export class AddStepsDialogTabs {
  static PUBLISHED = 'Published';

  static PREDICTED = 'Predicted';

  static get allTabs() {
    return [AddStepsDialogTabs.PUBLISHED, AddStepsDialogTabs.PREDICTED];
  }
}

export class ErrorNumbers {
  static PREDICTED_NOT_SUPPORTED_FOR_STRUCTURE = 34;
}

export const DEFAULT_DATA_PAGE_SIZE = 10;
